export default "__VITE_ASSET__2721b6bb__"